import React, { useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../utils/constants";
import { useSelector } from "react-redux";
import {
  FaCheckCircle,
  FaInfoCircle,
  FaWifi,
  FaPhone,
  FaTv,
  FaPlug,
} from "react-icons/fa";
import {
  ContainerEstadoClienteStyled,
  ContainerTitle,
  ContainerData,
  ButtonBuscar,
  EstadoBadge,
  ServiciosSection,
  ServiciosList,
  ServicioChip,
  ServiciosEmpty
} from "./estadoClienteStyles";
import BackButton from "../backButton/BackButton";
import { registrarEvento } from "../../registro/registro";

const getServicioIcon = (servicio) => {
  const upper = servicio.toUpperCase();
  if (upper.includes("INTERNET")) return <FaWifi />;
  if (
    upper.includes("TELEVISION") ||
    upper.includes("PLAY") ||
    /\bTV\b/.test(upper)
  )
    return <FaTv />;
  if (
    upper.includes("LINEA") ||
    upper.includes("TELEFON") ||
    upper.includes("CENTRAL")
  )
    return <FaPhone />;
  if (upper.includes("COSTO") || upper.includes("ACTIVACION"))
    return <FaPlug />;
  return <FaCheckCircle />;
};

const EstadoCliente = () => {
  const currentUser = useSelector((state) => state.user.currentUser);

  const [inputValue, setInputValue] = useState("");
  const [cliente, setCliente] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleBuscar = async () => {
    if (!inputValue) return;

    try {
      setLoading(true);
      setError(false);

      const response = await axios.get(
        `${BASE_URL}/customer/api/v1/clientes/${inputValue}`,
        {
          headers: {
            Authorization: `Bearer ${currentUser?.data?.token}`,
          },
        }
      );

      setCliente(response.data.data);
      registrarEvento("cliente.consulta", `Consulta del cliente ${inputValue}`, {
        cliente: inputValue,
        encontrado: true,
      });
    } catch (err) {
      console.log(err);
      registrarEvento("cliente.consulta", `Consulta del cliente ${inputValue}`, {
        cliente: inputValue,
        encontrado: false,
        status: err?.response?.status ?? null,
      });
      setCliente(null);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  //console.log(cliente);

  return (
    <ContainerEstadoClienteStyled>
      <BackButton />
      <ContainerTitle>
        <h2>Verificar el estado del cliente</h2>

        <input
          type="number"
          placeholder="Número de cliente"
          min={1}
          max={99999999}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />

        <ButtonBuscar onClick={handleBuscar}>
          Buscar
        </ButtonBuscar>
      </ContainerTitle>

      <ContainerData>
        <h3>Datos del cliente</h3>

        {loading && <p>Buscando cliente...</p>}

        {cliente && !loading && (
          <>
            <p><strong>Número de cliente:</strong> {cliente.id}</p>
            <p><strong>Nombre:</strong> {cliente.nombre}</p>
            <p><strong>Apellido:</strong> {cliente.apellido}</p>
            <p>
              <strong>Estado:</strong>{" "}
              <EstadoBadge
                $connected={cliente.estado?.toLowerCase().trim() === "conectado"}
              >
                {cliente.estado}
              </EstadoBadge>
            </p>
            <p><strong>Sucursal:</strong> {cliente.sucursal?.nombre}</p>

            <ServiciosSection>
              <h4>Servicios</h4>
              {(() => {
                const items = (cliente.servicios || "")
                  .split(";")
                  .map((s) => s.trim())
                  .filter(Boolean);
                if (items.length === 0) {
                  return (
                    <ServiciosEmpty>
                      <FaInfoCircle /> No hay servicios asignados
                    </ServiciosEmpty>
                  );
                }
                return (
                  <ServiciosList>
                    {items.map((servicio, index) => (
                      <ServicioChip key={index}>
                        {getServicioIcon(servicio)} {servicio}
                      </ServicioChip>
                    ))}
                  </ServiciosList>
                );
              })()}
            </ServiciosSection>
          </>
        )}

        {error && !loading && (
          <p>No se encontraron datos para el número de cliente ingresado.</p>
        )}
      </ContainerData>
    </ContainerEstadoClienteStyled>
  );
};

export default EstadoCliente;